import { ReactNode } from "react"

export type EnvInfo = {
    parameters: EnvParameters,
    hint?: ReactNode
}

export type ParamInfo = { placeholder: string, type: 'int'|'string'|'float' }

export type EnvParameters = Record<string, ParamInfo>

export const getEnvParameters = (license: string): EnvInfo|undefined => {
    switch(license) {
        case 'tsclient':
            return {
                parameters: { 'TokenServer': {placeholder:'<hostname>', type:'string' } },
                hint: <>The <code>TokenServer</code> parameter should point to the machine where you're running the Gurobi Token Server. If using a custom port or password, also specify the <code>TSPort</code> or <code>ServerPassword</code> parameters.</>
            }
        case 'ic':
            return {
                parameters: {
                    'CloudAccessID': { placeholder:'<access ID>', type:'string' },
                    'CloudSecretKey': { placeholder:'<secret key>', type: 'string' },
                    'CloudPool': { placeholder:'<pool name>', type:'string' },
                },
                hint: <>Values for the parameters can be found in the Instant Cloud license file you downloaded earlier.</>
            }
        case 'csclient':
            return {
                parameters: {
                    'ComputeServer': { placeholder:'<hostname>', type:'string' },
                    'ServerPassword': { placeholder: '<password>', type:'string' },
                },
                hint: <>The <code>ComputeServer</code> parameter should point to the machine where you're running the Gurobi Compute Server. <code>ServerPassword</code> should contain the corresponding password.</>
            }
        case 'cmclient':
            return {
                parameters: {
                    'CSManager': { placeholder: '<hostname>', type: 'string' },
                    'Username': { placeholder: '<username>', type: 'string' },
                    'ServerPassword': { placeholder: '<password>', type: 'string' },
                },
                hint: <>The <code>CSManager</code> parameter should point to the machine where you're running the Gurobi Cluster Manager. When using a username/password, use the <code>UserName/ServerPassword</code> parameters. When using an API key, specify the <code>CSAPIAccessID/CSAPISecret</code> parameters instead.</>                
            }
        case 'wlssu':
        case 'wlsuu':
            return {
                parameters: {
                    'LicenseID': { placeholder: '<licenseID>', type: 'int' },
                    'WLSAccessID': { placeholder: '<access ID>', type: 'string' },
                    'WLSSecret': { placeholder: '<secret key>', type: 'string' },
                },
                hint: <>Values for the parameters can be found in the WLS license file you downloaded earlier.</>
            }
        default: 
            return undefined
    }
}
